// @core/api/endpoints/team/get_current_schedule_assignee.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetCurrentScheduleAssigneeResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Get current schedule assignee
 * Retrieves current schedule assignee by the specified identifier.
 */
export async function GetCurrentScheduleAssignee(
  team_id: string,
  schedule_id: string,
  options?: RequestOptions
): Promise<GetCurrentScheduleAssigneeResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/schedules/:schedule_id/current`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':schedule_id', encodeURIComponent(schedule_id));
  const requestOptions = options;
  return client.get<GetCurrentScheduleAssigneeResponse>(requestPath, { ...requestOptions });
}
